// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-N":"N_shp2-detail-N__Hn36b"};